import React, {useEffect, useState} from "react";
import {getStockValuationFxn, getStockValuationReportFxn} from "../actions";
import {Card, Table} from "../../../components/Elements/appUtils";
import moment from "moment";
import InputBoxComponent from "../../../components/Elements/InputBox";

const OpdReport = () => {
    const [reportData, setReportData] = useState([]);
    const [totalValuation, setTotalValuation] = useState(0);
    const [openingValue, setOpeningValue] = useState(0);
    let [date, setDate] = useState(moment().subtract(1, 'day').format('YYYY-MM-DD'));
    const getReportFxn = async (params = {}) => {
        try {
            const {data = {}} = await getStockValuationReportFxn({...params, date});

            const {
                data: report = [],
                totalValue = 0,
                openingValue = 0
            } = data;

            setReportData(report);
            setTotalValuation(totalValue);
            setOpeningValue(openingValue);

        } catch (error) {
            setReportData([]);
            setTotalValuation(0);
            setOpeningValue(0);
            console.error("getReportFxn error:", error);
        }
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, [date]);


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Product Name",
            dataIndex: "productName",
            key: "productName",
        },
        {
            title: "Product Code",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "HSN",
            dataIndex: "hsnCode",
            key: "hsnCode",
        },

        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (item) => {
                return item ? `Rs. ${item.toFixed(2)}` : null
            }
        },
        {
            title: "Batch",
            dataIndex: "records",
            key: "records",
            width: '30%',
            render: (record) => {
                return (
                    <>
                        <ul className={'ul-sm'}>
                            {record.map((item) => {
                                return (
                                    <li key={item._id}>
                                        <div>
                                            <span>{item.batchNo}</span>
                                            <span>{item.quantity} x Rs. {item.price} = <strong>Rs. {item.total.toFixed(2)}</strong></span>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </>
                )
            }
        },
    ];

    return (
        <Card title={`Stock Valuation - (Opening Value - Rs. ${openingValue.toFixed(2)})`} actions={(
            <>
                Total Valuation : <strong>Rs. {totalValuation.toFixed(2)}</strong>
            </>
        )}>
            <div className={'row'}>
                <div className="col-md-3">
                    <InputBoxComponent title={'Choose Date'} customStyle={{padding: "0 10px 20px"}}>
                        <input
                            type="date"
                            className="form-control"
                            value={date}
                            onChange={(e) =>
                                setDate(e.target.value)
                            }
                        />
                    </InputBoxComponent>
                </div>

            </div>
            <div className="row ">
                <div className="col-md-12" key={reportData.length}>
                    <div>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OpdReport;
